import { http } from "./http";

export interface CampaignView {
  id: string;
  hospId: string;
  title: string;
  description: string | null;
  imageUrl: string | null;
  priceSale: number | null;
  isActive: boolean;
  startDate?: string | null;
  endDate?: string | null;
  heroBannerId?: string | null;
  type?: string;
  packageCode?: string | null;
  additionalImages?: any | null;
  isRecommended?: boolean;
  features?: any | null;
  suitableFor?: any | null;
  additionalInfo?: string | null;
  examItems?: any | null;
}

export const promotionApi = {
  // Active campaigns for the customer's hospital
  async campaigns(): Promise<CampaignView[]> {
    const { data } = await http.get<CampaignView[]>(
      "/public/promotion/campaigns",
    );
    return data;
  },
};
